
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import PageFooter from '@/components/page-footer.vue';
  import {
    getProviderAfterInfo
  } from '@/api/after_sales';
  import {afterSalesTypes} from '@/utils/config';

  @Component({
    name: 'supplier-after-detail',
    components: {
      PageFooter,
    }
  })
  export default class SupplierAfterDetail extends Vue {
    private providerId = +this.$route.query.id;
    private orderStrKey = '';
    private productKey = '';
    private filterTime: any = '';
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private list: any = [];
    private refundType: any = afterSalesTypes;

    private mounted() {
      this.getList();
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }

    private clearSearch() {
      this.orderStrKey = '';
      this.productKey = '';
      this.filterTime = '';
      this.pageNo = 1;
      this.getList();
    }

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }

    private async getList() {
      let params: any = {
        provider_id: this.providerId,
        page_no: this.pageNo,
        page_size: this.pageSize,
      }
      if (this.filterTime && this.filterTime.length) {
        params.begin_time = parseInt(this.filterTime[0] / 1000 + '');
        params.end_time = parseInt(this.filterTime[1] / 1000 + '');
      }
      if (this.orderStrKey) {
        params.order_str_id = this.orderStrKey; 
      }
      if (this.productKey) {
        params.product_name = this.productKey;
      }
      try {
        const res: any = await getProviderAfterInfo(params);
        this.list = res.info || []
        this.total = res.count;
      }catch(err) {
        console.error('getProviderAfterInfo==>', err);
      }
    }
  }
